module.exports = __webpack_public_path__ + "img/icon-arrow-back.5612548a.svg";